<template>
    <RectangleTile class="pa-4 profile-stat-tile">
        
        <template v-slot:icon>
            <TileIcon class="profile-stat-tile__icon">
                <slot name="icon"></slot>
            </TileIcon>
        </template>


        <template v-slot:details>
            <TileDetails>
                <template v-slot:name>
                    <span class="profile-stat-tile__title">
                        <slot name="name"> </slot>
                    </span>
                </template>
                <template v-slot:description>
                    <span class="profile-stat-tile__description">
                        <slot name="description"> </slot>
                    </span>
                </template>
            </TileDetails>
        </template>

    </RectangleTile>
</template>



<script setup>

import TileIcon from "@/components/Common/Tile-Icon.vue";
import TileDetails from "@/components/Common/Tile-Details.vue";
import RectangleTile from "@/components/Tiles/Rectangle-Tile.vue";

</script>